import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { RadioChangeEvent } from 'antd/lib/radio';
import { get } from 'lodash';
import { Form, Radio, Select } from 'antd';

import { RootState } from '@share/utils';
import { ICompanyProfileState, ILoginState, IMenuState, IMyProfileState } from '@share/store/slices';
import { IUserCard } from '@share/common-types';

import { CreditCardItem } from './credit-card-item';

import './style.scss';
import { CompanyCreditCardItem } from './company-credit-card-item';

interface IMapStateToProps {
  myProfileStore: IMyProfileState;
  menuStore: IMenuState;
  loginStore: ILoginState;
  companyProfileStore: ICompanyProfileState;
}

interface IProps extends IMapStateToProps, RouteComponentProps, WrappedComponentProps {
  selectable?: boolean;
  hideDelete?: boolean;
  hideIfNoData?: boolean;
  isCheckout?: boolean;
  isCompany?: boolean;
  selectedCardId?: string;
  onSelectCard?: (selectedCard: IUserCard) => void;
}

function CreditCardsListComponent(props: IProps) {
  const {
    myProfileStore,
    loginStore,
    menuStore,
    selectable,
    hideDelete,
    hideIfNoData,
    isCheckout,
    selectedCardId,
    onSelectCard,
    isCompany,
    companyProfileStore
  } = props;
  const { result, loadingCards } = myProfileStore;
  const { result: companyResult, loadingCards: companyLoadingCards } = companyProfileStore;
  const { companyCards } = companyResult;
  const { account } = loginStore;
  const { items } = menuStore;
  const { userCards } = result;
  const [form] = Form.useForm();
  const handleOnChange = (selectedValue: RadioChangeEvent) => {
    if (onSelectCard) {
      const selectedCard: any = get(
        userCards?.filter((c: any) => c?.id === selectedValue.target.value),
        '[0]',
      );
      onSelectCard(selectedCard);
    }
  };

  if (hideIfNoData && !userCards?.length && !loadingCards) {
    return null;
  }

  const handleSelectChange = (value: string) => {
    if (onSelectCard) {
      const userCard = userCards?.find((c: any) => c?.id === value);
      const companyCard = companyCards?.find((c: any) => c?.id === value);
      const selectedCard = userCard || companyCard;
      onSelectCard(selectedCard as any);
    }
  };

  return (
    <>
      <h4 className="payment-method__title secondary-font" style={{ marginBottom: '15px' }}>
        <FormattedMessage id="available.cards" />
      </h4>

      <div style={{ marginBottom: isCheckout ? '0px' : '25px' }}>
        {userCards?.length && !isCompany ? (
          <div className="credit-cards-list__credit-card-container">
            {selectable ? (
              <Radio.Group value={selectedCardId} onChange={handleOnChange} disabled={loadingCards}>
                {userCards.map((card, index) => (
                  <Radio key={index} value={card?.id}>
                    <CreditCardItem card={card} hideDelete={hideDelete} />
                  </Radio>
                ))}
              </Radio.Group>
            ) : (
              userCards.map((card, index) => (
                <CreditCardItem key={index} card={card} hideDelete={hideDelete} />
              ))
            )}
          </div>
        ) : isCompany ? (
          <div className="credit-cards-list__credit-card-container">
            <Form
              form={form}
              initialValues={{ cardId: 'default' }}
              onFinish={handleOnChange}
              layout="vertical"
              className="mb-0"
            >
              <Form.Item
                name="cardId"
              >
                <Select
                  placeholder="Default"
                  className="customSelect"
                  onChange={handleSelectChange}
                >
                  {userCards?.length > 0 && (
                    <Select.OptGroup label={<span className="fw-bold text-dark">User Cards</span>} disabled >
                      {userCards.map((card, index) => (
                        <Select.Option key={`user-${index}`} value={card?.id}>
                          <CreditCardItem card={card} hideDelete={hideDelete || selectedCardId === card?.id} />
                        </Select.Option>
                      ))}
                    </Select.OptGroup>
                  )}
                  
                  {/* Company Cards Section */}
                    {companyCards?.length > 0 && (
                      <Select.OptGroup label={<span className="fw-bold text-dark">Company Cards</span>} disabled>
                      {companyCards.map((card, index) => (
                        <Select.Option key={`company-${index}`} value={card?.id}>
                          <CompanyCreditCardItem card={card} hideDelete={hideDelete || selectedCardId === card?.id}/>
                        </Select.Option>
                      ))}
                    </Select.OptGroup>
                  )}
                </Select>
              </Form.Item>
            </Form>
          </div>
        ) : (
          <FormattedMessage id="available.cards.no_card" />
        )}
      </div>

      {account?.enableInsurance && !items?.isRemoveInsurance ? (
        <div style={{ marginBottom: isCheckout ? '0px' : '25px', marginTop: '10px' }}>
          <FormattedMessage id="insurance.saved_card" />
        </div>
      ) : null}
    </>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    myProfileStore: state.myProfileStore,
    menuStore: state.navigationMenuStore,
    loginStore: state.loginStore,
    companyProfileStore: state.companyProfileStore,
  };
};

const ComponentIntl = injectIntl(CreditCardsListComponent);

export const CreditCardsList = connect(mapStateToProps)(withRouter(ComponentIntl));
